import { Component, computed, inject, input, signal, viewChild } from "@angular/core";
import { Router } from "@angular/router";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";

import { AdaaHelper } from "../../../../core/utils";
import { DataTableComponent, FormActionButtonsComponent } from "../../../../shared/components";
import { SmartTooltipsInfoEditorModalComponent } from "../../../../shared/components/modals/smart-tooltips-info-editor-modal/smart-tooltips-info-editor-modal";
import { Constants } from "../../../../shared/constants/constants";
import { TableButtonClicked, TableInputs, TableValueListOutput } from "../../../../shared/models/data-table-model";
import { MandatoryFields } from "../../../../shared/models/mandatory-fields-model";
import { MandatoryApiService } from "../../../../shared/services/mandatory-api-service";

@Component({
  selector: "adaa-smart-tooltips-list-editor",
  imports: [DataTableComponent, TranslatePipe, SmartTooltipsInfoEditorModalComponent, FormActionButtonsComponent],
  templateUrl: "./smart-tooltips-list-editor.html",
  styleUrl: "./smart-tooltips-list-editor.scss",
})
export class SmartTooltipsListEditorComponent {
  private _router = inject(Router);
  private _translateService = inject(TranslateService);
  private _toastrService = inject(ToastrService);
  private _mandatoryApiService = inject(MandatoryApiService);

  Constants = Constants;
  field = signal<MandatoryFields>({
    name: "",
    searchKey: "",
    mandatory: "",
    parameterCatalogs: [],
  });
  data = signal<MandatoryFields["parameterCatalogs"]>([]);
  id = input.required<string>();
  smartTooltipsInfo = viewChild.required<SmartTooltipsInfoEditorModalComponent>("info");
  adaaDataTable = viewChild.required<DataTableComponent>("adaaDataTable");
  tootTipId: number;
  tableInputs = computed<TableInputs[]>(() => [
    {
      fieldName: "status",
      checkboxMode: "trueFalse",
    },
  ]);
  displayLabel = computed(() => AdaaHelper.getItemValueByToken(this.field(), "name"));

  public ngOnInit(): void {
    if (this.id())
      this._mandatoryApiService.getMandatoryFieldsBySearchKey(this.id()).subscribe((response) => {
        const params = response.responseData.parameterCatalogs.sort((a, b) => (a.nameEN > b.nameEN ? 1 : -1));
        this.data.set(params);
        this.field.set(response.responseData);
      });
  }

  public getAction(value: TableButtonClicked) {
    this.tootTipId = value.data.id;
    switch (value.event) {
      case "edit":
        this.smartTooltipsInfo().toolTipInfoForm.patchValue(value.data);
        this.smartTooltipsInfo().open();
        break;

      default:
        break;
    }
  }

  public setInfo(value: { descriptionAE: string; descriptionEN: string }) {
    const data: MandatoryFields["parameterCatalogs"] = AdaaHelper.clone(this.data());
    const index = data.findIndex((field) => field.id === this.tootTipId);
    if (index !== -1) {
      data[index].descriptionAE = value.descriptionAE;
      data[index].descriptionEN = value.descriptionEN;
    }
    this.data.set(data);
  }

  public submit() {
    let res = {
      ...this.field(),
      parameterCatalogs: this.data(),
    };
    res = Object.fromEntries(Object.entries(res).filter(([_, value]) => value !== null)) as MandatoryFields;

    this._mandatoryApiService.updateMandatoryFields(false, res).subscribe((response) => {
      if (response.inError) return;
      this._toastrService.success(this._translateService.instant("notification.success.save"));
      this._router.navigateByUrl("console/help/smart-tool-tips");
    });
  }

  public close() {
    this._router.navigateByUrl("console/help/smart-tool-tips");
  }

  public onTableDataChanged(event: TableValueListOutput[]) {
    const data: MandatoryFields["parameterCatalogs"] = AdaaHelper.clone(this.data());
    for (const item of event) {
      const index = data.findIndex((field) => field.id === item.data.id);
      if (index !== -1) {
        data[index].status = item.value;
      }
    }
    this.data.set(data);
  }
}
